import { MainV3ApiBase } from './base';
import { EntranceFeeShowView } from '../types/entranceFees';

export const EntranceFeeApis = {
  base() {
    return MainV3ApiBase.appendPath('users/current/entrance_fee');
  },
  show(
    defaultEntranceFee = false,
    email: string | undefined = undefined,
    couponCode: string | undefined = undefined
  ): Promise<EntranceFeeShowView> {
    return this.base().get({ default: defaultEntranceFee, email, coupon_code: couponCode });
  },
};
